(function() { window.GUID_834b50c2_bb24_43b3_8203_efc41650211d = { getGuid: function() { return "834b50c2-bb24-43b3-8203-efc41650211d"; } }; })();
var CS;
(function (CS) {
    let $iframe = null;
    function ShowPrintDialog(url) {
        if ($iframe != null && $iframe.length > 0) {
            let iframe = $iframe[0];
            iframe.src = url;
        }
        else {
            $iframe = $('<iframe id="AutoPrintDialogPdf" style="display:none;"></iframe>');
            let iframe = $iframe[0];
            iframe.src = url;
            iframe.onload = function () {
                setTimeout(function () {
                    iframe.focus();
                    iframe.contentWindow.print();
                }, 1);
            };
            CS.body.append($iframe);
        }
    }
    CS.ShowPrintDialog = ShowPrintDialog;
})(CS || (CS = {}));

//# sourceMappingURL=autoprintdialog.js.map
